var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('contribute-button');
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
import { Icons } from '../icons';
import { useContributeForm } from '../../hooks/use-contribute-form';
import { useFullscreen } from '../../hooks/use-fullscreen';
import { BANNER_CONTROLS_WIDTH } from './banner-controls';
import { withOwnProvider } from '../../utils/with-own-provider';
import { HTML } from './html';
export var ContributeButtonDefaultProps = {
  label: '<b>Give your feedback</b> on this content, or submit insights and solutions',
  backgroundColor: '#EFEEEE',
  color: 'dark',
  buttonBackgroundColor: '#969696',
  buttonHoverBackgroundColor: '#969696',
  buttonColor: 'light',
  buttonHoverColor: 'light',
  iconColor: '#969696'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n\n    font-size: ", ";\n    border: none;\n    font-weight: 300;\n    cursor: pointer;\n    padding: 0;\n    line-height: 1.5em;\n    display: flex;\n    align-items: stretch;\n    font-family: ", ";\n    b {\n      font-weight: 400;\n    }\n\n  "], ["\n    ", "\n\n    font-size: ", ";\n    border: none;\n    font-weight: 300;\n    cursor: pointer;\n    padding: 0;\n    line-height: 1.5em;\n    display: flex;\n    align-items: stretch;\n    font-family: ", ";\n    b {\n      font-weight: 400;\n    }\n\n  "])), function (_a) {
    var _color = _a._color,
        _backgroundColor = _a._backgroundColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n      background: ", ";\n    "], ["\n      color: ", ";\n      background: ", ";\n    "])), theme.COLOR(_color), theme.COLOR(_backgroundColor));
  }, theme.FONT_SIZE(16), theme.FONT('sans')),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(14)),
  desktopLarge: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(16)),
  desktopFullHD: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    &.is-fullscreen {\n      font-size: ", ";\n    }\n  "], ["\n    &.is-fullscreen {\n      font-size: ", ";\n    }\n  "])), theme.FONT_SIZE(13))
});
var BodyStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    padding: ", ";\n\n    ", "\n\n    display: flex;\n    align-items: center;\n  "], ["\n    padding: ", ";\n\n    ", "\n\n    display: flex;\n    align-items: center;\n  "])), theme.UNIT(5), function (props) {
    return !props.padBodyAtRight && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding-right: 0;\n    "], ["\n      padding-right: 0;\n    "])));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n    \n    flex-shrink: 0;\n    margin-right: ", ";\n  "], ["\n    ", "\n    \n    flex-shrink: 0;\n    margin-right: ", ";\n  "])), function (_a) {
    var _color = _a._color;
    return css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      ", ";\n    "], ["\n      ", ";\n    "])), theme.FILL(_color));
  }, theme.UNIT(4)),
  desktop: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    width: 42px;\n    height: 42px;\n  "], ["\n    width: 42px;\n    height: 42px;\n  "]))),
  desktopLarge: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    width: 48px;\n    height: 48px;\n  "], ["\n    width: 48px;\n    height: 48px;\n  "])))
});
var TextStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    text-align: left;\n  "], ["\n    text-align: left;\n  "])))
});
var ArrowStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n\n    ", "\n  "])), function (_a) {
    var _color = _a._color,
        _backgroundColor = _a._backgroundColor;
    return css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      background: ", ";\n      ", ";\n    "], ["\n      background: ", ";\n      ", ";\n    "])), theme.COLOR(_backgroundColor), theme.FILL(_color));
  })
});
var ArrowIconStyles = breakpoints({
  base: css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    width: ", "px;\n  "], ["\n    width: ", "px;\n  "])), BANNER_CONTROLS_WIDTH)
}); // -------- Components -------->

var My = {
  Container: styled.button(templateObject_16 || (templateObject_16 = __makeTemplateObject([""], [""]))),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Icon: styled(Icon)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Text: styled.span.attrs(cls.attr('text'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), TextStyles),
  Arrow: styled.div.attrs(cls.attr('arrow'))(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), ArrowStyles),
  ArrowIcon: styled(Icon)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), ArrowIconStyles)
};
My.Container = styled.button(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  ", ";\n\n  &:hover {\n    ", " {\n      ", "\n    }\n  }\n"], ["\n  ", ";\n\n  &:hover {\n    ", " {\n      ", "\n    }\n  }\n"])), ContainerStyles, My.Arrow, function (_a) {
  var _buttonHoverBackgroundColor = _a._buttonHoverBackgroundColor,
      _buttonHoverColor = _a._buttonHoverColor;
  return css(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n        background: ", ";\n        ", ";\n      "], ["\n        background: ", ";\n        ", ";\n      "])), theme.COLOR(_buttonHoverBackgroundColor), theme.FILL(_buttonHoverColor));
});
export var ContributeButtonComponent = function ContributeButtonComponent(props) {
  var className = props.className,
      onClick = props.onClick,
      children = props.children,
      backgroundColor = props.backgroundColor,
      buttonBackgroundColor = props.buttonBackgroundColor,
      buttonColor = props.buttonColor,
      buttonHoverColor = props.buttonHoverColor,
      buttonHoverBackgroundColor = props.buttonHoverBackgroundColor,
      color = props.color,
      iconColor = props.iconColor;
  var fs = useFullscreen();
  var contributeForm = useContributeForm();
  var padBodyAtRight = buttonBackgroundColor !== backgroundColor;
  var icon = props.icon || React.createElement(Icons.ChatBubble, null);
  var label = process.env.CONTRIBUTE_BUTTON_LABEL || props.label;
  return React.createElement(My.Container, {
    _buttonHoverBackgroundColor: buttonHoverBackgroundColor,
    _buttonHoverColor: buttonHoverColor,
    _color: color,
    _backgroundColor: backgroundColor,
    onClick: onClick || contributeForm.showOnClick,
    className: cls.name(className) + " " + fs.className
  }, React.createElement(My.Body, {
    padBodyAtRight: padBodyAtRight
  }, React.createElement(My.Icon, {
    _color: iconColor
  }, icon), React.createElement(My.Text, null, children || React.createElement(HTML, {
    text: label
  }))), React.createElement(My.Arrow, {
    _color: buttonColor,
    _backgroundColor: buttonBackgroundColor
  }, React.createElement(My.ArrowIcon, {
    size: 28
  }, React.createElement(Icons.ChevronLeft, null))));
};
export var ContributeButton = withOwnProvider(ContributeButtonComponent);
ContributeButton.defaultProps = ContributeButtonDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23;